<template>
  <div class="entity-data">
    <div v-if="isBusy || is.loading" class="form-busy">
      <c-loader inline scale="2.5"/>
    </div>

    <template v-else>
      <div class="data-content">
        <b-row>
          <template v-for="property in properties">
            <b-col v-if="(property._table || {}).title" :key="`${property.name}_title`" cols="12" class="group-title">
              <h4>{{ property._table.title }}</h4>
            </b-col>

            <template v-if="property.visible">
              <b-col :key="`${property.control.id}_label`" :[$root.mobile.up.key]="4" class="data-col-label">
                <label :for="property.name">{{ property.control.label }}</label>
              </b-col>

              <b-col :key="`${property.control.id}_value`" :[$root.mobile.up.key]="8" class="data-col-value">
                <div v-html="valueFormatter(definition, property.name, property.control.value).html"/>
              </b-col>
            </template>
          </template>
        </b-row>
      </div>
    </template>
  </div>
</template>

<script>
import { valueFormatter, propertyMapper } from '@/assets/js/helper/entity'

export default {
  name: 'Entity.data',
  props: {
    isBusy: {
      type: Boolean,
      default: false
    },
    entityKey: {
      type: String,
      required: true
    },
    entityId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      controls: {}
    }
  },
  computed: {
    storeKey () {
      return this.entityKey.toLowerCase()
    },
    is () {
      return this.$store.getters[`${this.storeKey}/is`]
    },
    definition () {
      return this.$store.getters[`${this.storeKey}/definition`]
    },
    entity () {
      return this.$store.getters[`${this.storeKey}/getEntity`](this.entityId) || {}
    },
    properties () {
      return propertyMapper(this.definition, this.$store.getters['gui/getLanguage'], [], this.entity)
    }
  },
  methods: {
    valueFormatter
  }
}
</script>

<style lang="scss">
$entity-data-padding-y: 0 !default;
$entity-data-padding-x: 0 !default;
$entity-data-border: $border-width $border-style $border-color !default;

$entity-data-group-title-gap: $spacer * 1.25 !default;
$entity-data-group-title-margin-bottom: $entity-data-group-title-gap * 0.75 !default;
$entity-data-group-title-padding: ($spacer * 0.1) 0 !default;
$entity-data-group-title-font-size: $h5-font-size !default;
$entity-data-group-title-font-weight: $font-weight-bold !default;
$entity-data-group-title-color: $secondary !default;

$entity-data-col-label-gap: 0 !default;

$entity-data-label-font-size: $font-size-base !default;
$entity-data-label-font-weight: $font-weight-bold !default;
$entity-data-label-color: inherit !default;

$entity-data-col-value-gap: $entity-data-col-label-gap !default;

$entity-data-value-font-size: $entity-data-label-font-size !default;
$entity-data-value-font-weight: inherit !default;
$entity-data-value-color: inherit !default;

$entity-data-changerequests-border-width: $input-border-width !default;
$entity-data-changerequests-border-color: $info !default;
$entity-data-changerequests-font-size: $font-size-sm * 0.85 !default;
$entity-data-changerequests-color: $entity-data-changerequests-border-color !default;

$entity-data-action-gap: $spacer * 0.5 !default;

$entity-data-disabled-bg: $gray-100 !default;
$entity-data-disabled-color: inherit !default;

$entity-data-mobile-breakpoint: $mobile-breakpoint !default;

$entity-data-mobile-col-label-gap: $spacer * 0.5 !default;
$entity-data-mobile-col-value-gap: 0 !default;

.entity-data {
  position: relative;
  padding: $entity-data-padding-y $entity-data-padding-x;

  &:first-child {
    margin-top: $entity-data-padding-y * -1;
  }

  + .entity-data {
    padding: $entity-data-padding-y $entity-data-padding-x;
    border-top: $entity-data-border;
  }

  .data-content {
    .group-title {
      > * {
        margin-top: $entity-data-group-title-gap;
        margin-bottom: $entity-data-group-title-margin-bottom;
        padding: $entity-data-group-title-padding;
        font-size: $entity-data-group-title-font-size;
        font-weight: $entity-data-group-title-font-weight;
        color: $entity-data-group-title-color;
      }

      &:first-child {
        > * {
          margin-top: 0;
        }
      }
    }

    .form-group {
      margin-bottom: 0;

      .input-group {
        margin-bottom: 0!important;
      }
    }

    .data-col-label {
      display: flex;
      align-items: center;
      margin-top: $entity-data-col-label-gap;

      label {
        display: block;
        margin: 0;
        font-size: $entity-data-label-font-size;
        font-weight: $entity-data-label-font-weight;
        color: $entity-data-label-color;
      }

      &:first-child {
        margin-top: 0;

        + .data-col-value {
          margin-top: 0;
        }
      }
    }

    .data-col-value {
      margin-top: $entity-data-col-value-gap;
      font-size: $entity-data-value-font-size;
      font-weight: $entity-data-value-font-weight;
      color: $entity-data-value-color;

      > * {
        font-size: inherit;
        font-weight: inherit;
        color: inherit;
      }

      .control-checkbox,
      .control-radio {
        padding-top: $input-padding-y;
      }

      .data-changerequests {
        position: relative;
        margin-top: $entity-data-changerequests-border-width * -1;
        border-top: $entity-data-changerequests-border-width solid $entity-data-changerequests-border-color;
        font-size: $entity-data-changerequests-font-size;
        color: $entity-data-changerequests-color;
        z-index: 3;
      }

      .is-valid,
      .is-invalid {
        + .data-changerequests {
          border-top-color: transparent;
        }
      }
    }
  }

  .form-action {
    margin: $entity-data-action-gap ($entity-data-padding-x * -1) 0;
  }

  .form-info {
    position: absolute;
    bottom: $entity-data-padding-y;
    right: $entity-data-padding-x;
  }

  &.is-approved {}

  &.is-editmode {
    .entitydata-content {
      .data-col-label {
        label {
          padding-top: $input-padding-y;

          &.label-sm {
            padding-top: $input-padding-y-sm;
          }

          &.label-lg {
            padding-top: $input-padding-y-lg;
          }
        }
      }
    }
  }

  &.is-disabled {
    margin-top: 0;
    background-color: $entity-data-disabled-bg;
    color: $entity-data-disabled-color;
  }

  @include media-breakpoint-down($entity-data-mobile-breakpoint) {
    .data-content {
      .data-col-label {
        margin-top: $entity-data-mobile-col-label-gap;

        &:first-child {
          margin-top: 0;

          + .data-col-value {
            margin-top: 0;
          }
        }
      }

      .data-col-value {
        margin-top: $entity-data-mobile-col-value-gap;
      }
    }
  }
}
</style>
